import classes from './Title.module.scss';

export const Title = ({ title }: { title: string }) => {
  return (
    <div className={classes.titleWrapper}>
      <h1 className={classes.sectionTitle}>{title}</h1>
      <img
        src="/separateur.png"
        alt="Separation"
        className={`${classes.horizontalSectionDivider} mb-5`}
      />
    </div>
  );
};
